<template>
    <div class='the-shield-of-zeus text-center'>
        <div class="jackpot-multiplier" v-if="this.ticket.scenario.multiplier > 1">
            <h6 class="text-center pt-3">{{'multiplier' | lang}}</h6>
            <img class="img-fluid" :src="`/fg/v2/games/the_shield_of_zeus/img/X${this.ticket.scenario.multiplier}.png`">
        </div>
        <h6 class="text-center">{{'lucky_symbols' | lang}}</h6>
        <div class="lucky-symbols w-100 d-flex align-items-center justify-content-center">
            <div v-for="(symbol, itemIndex) in luckySymbols" :key="itemIndex" :class="{'jackpot-symbol':symbol === 'bonus_all_symbol','symbol d-flex align-items-center justify-content-center':true, 'lucky' : luckySymbolsArray.includes(symbol) || symbol === 'bonus_all_symbol'}"> 
                <div v-if="symbol === 'bonus_all_symbol'">
                    <div class="w-100">
                        <img class="img-fluid" :src="`/fg/v2/games/the_shield_of_zeus/img/history/Jacpot_Indicator_Opened.png`">
                        <img class="img-fluid inside" :src="`/fg/v2/games/the_shield_of_zeus/img/jackpot_indicator_symbol_${ticket.scenario.win_all_bonus.symbol}.png`">
                    </div>
                </div>

                <img v-else class="img-fluid" :src="`/fg/v2/games/the_shield_of_zeus/img/history/symbol_${symbol}_gold.png`">
            </div>
        </div>
        <div v-if="luckyYourSymbols.length || luckyBonusSymbols.length" class="">
            <div v-if="luckyYourSymbols.length">
                <h6 class="text-center pt-3">{{'your_symbols' | lang}}</h6>
                <div class="your-symbols w-100 d-flex align-items-center justify-content-center justify-content-lg-start flex-wrap">
                    <div v-for="(item, itemIndex) in luckyYourSymbols" :key="itemIndex" class="symbol"> 
                        <img class="img-fluid" :src="`/fg/v2/games/the_shield_of_zeus/img/history/symbol_${item.symbol ? (item.symbol === 'bonus_all_symbol' ? ticket.scenario.win_all_bonus.symbol : item.symbol) : item}_light.png`">
                        <span class="amount" v-if="item.amount">
                            {{item.amount}}
                        </span>
                    </div>
                </div>
            </div>
            <div v-if="luckyBonusSymbols.length">
                <h6 class="text-center pt-3" >{{'bonus' | lang}}</h6>
                <div class="bonus-symbols w-100 d-flex align-items-center justify-content-start flex-wrap">
                    <div class="card-holder" v-for="(amount, itemIndex) in luckyBonusSymbols" :key="itemIndex">
                        <span class="amount">{{amount}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class = 'no-winnings d-flex align-items-center justify-content-center'>
            <h6>{{'noWinning' | lang}}</h6>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['ticket', 'gameName'],
        data() {
            return {
                luckySymbolsArray:[]
            }
        },
        computed: {
            luckySymbols() {
                let luckies = [];
                this.luckySymbolsArray = [];

                for (const [key, symbol] of Object.entries(this.ticket.scenario.lucky_symbols)) {
                    luckies.push(symbol);

                    if (parseInt(key) === 1) {
                        luckies.push('bonus_all_symbol');
                    }
                }

                return luckies;
            },
            luckyYourSymbols() {
                let luckies = [];
                this.luckySymbolsArray = [];

                for (const [key, symbol] of Object.entries(this.ticket.scenario.your_symbols)) {
                    if (symbol === 'bonus_symbol') {
                        this.luckySymbolsArray.push(symbol);
                    } else if (symbol.symbol === 'bonus_all_symbol') {
                        luckies.push(symbol);
                    } else if (symbol.win) {
                        luckies.push(symbol);
                        this.luckySymbolsArray.push(symbol.symbol);
                    }
                }

                return luckies;
            },
            luckyBonusSymbols() {
                let luckies = [];

                if (this.ticket.scenario.bonus && this.ticket.scenario.bonus.luckies) {
                    for (const [key, amount] of Object.entries(this.ticket.scenario.bonus.luckies)) {
                        if (amount) {
                            luckies.push(amount);
                        }
                    }
                }

                return luckies;
            }
        }
    }
</script>

<style>
    .the-shield-of-zeus .symbol {
        width: 20%;
        padding: 5px;
        max-width: 80px;
        position: relative;
    }

    .the-shield-of-zeus .jackpot-multiplier img {
        width: 100px;
        margin-top: -20px;
    }

    .the-shield-of-zeus .lucky-symbols .symbol {
        opacity: 0.5;
    }

    .the-shield-of-zeus .lucky-symbols .symbol.lucky {
        opacity: 1;
    }

    .the-shield-of-zeus .lucky-symbols .symbol.jackpot-symbol {
        width: 24%;
        max-width: 100px;
    }

    .the-shield-of-zeus .lucky-symbols .symbol.jackpot-symbol .inside {
        position: absolute;  
        left: 0;
        width: 90%;
        left: 50%;
        transform: translate(-50%, -50%);
        top: 50%;
    }

    .the-shield-of-zeus .your-symbols .amount {
        position: absolute;
        bottom: -5px;
        text-align: center;
        font-family: Arial Black;
        width: 100%;
        font-size: 22px;
        margin-left: auto;
        margin-right: auto;
        color: #ffeec5;
        -webkit-text-stroke: 1.6px #d2a730;
        white-space: nowrap;
        transform: translateX(-50%);
        left: 50%;
    }

    .the-shield-of-zeus .bonus-symbols .amount {
        text-align: center;
        font-family: Arial Black;
        font-size: 2.2em;
        left: 0;
        margin-left: auto;
        margin-right: auto;
        color: #d0fbff;
        -webkit-text-stroke: 0.1rem #298ec1;
        white-space: nowrap;
        transform: translate(-50%,-50%);
        top: 50%;
        left: 50%;
        font-weight: bold;
    }

    .the-shield-of-zeus .no-winnings {
        height: 100px;
        width: 100%;
        border: 1px white dotted;
        border-radius: 10px;
        margin-top: 15px;
    }

    .the-shield-of-zeus .bonus-symbols .card-holder {
        position: relative;
        padding-left: 10px;
        padding-right: 10px;
    }

    .the-shield-of-zeus .bonus-symbols .card-holder .text-holder {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
    }
</style>